module.exports = __webpack_public_path__ + "static/wpack/extracted/quote0dac652c16e73af8acecc23401e2bbcb.svg";